module.exports = __webpack_public_path__ + "img/jd_logo_white.9afe2a30.png";